import React from 'react';
import { Field } from 'redux-form';
import FormGroup from 'Components/FormGroup';
import { FormStatusSelect } from 'Common/ReduxForm';
import { FormSwitch } from 'Common/ReduxForm';

export default function StatusForm(props) {
    return (
        <FormGroup title="form_groups.status" {...props}>
            <Field
                component={FormStatusSelect}
                name="is_active"
                rowClassName="mm-form-field"
                placeholder="is_active"
            />

            <Field
                component={FormSwitch}
                name="has_full_pool"
                rowClassName="mm-form-field"
                placeholder="has_full_pool"
                inputProps={{withControl: true, color: 'primary'}}
            />

        </FormGroup>
    );
}



// WEBPACK FOOTER //
// ./src/components/FormGroup/StatusForm.jsx